export enum MasterSection {
    Location,
    Items,
    UOMs
}
